export default class Navigation {
    constructor(options) {
        this.options = {
            ...{
                selector: '.main-navigation',
                activeClass: 'active',
                dropdownSelector: '.dropdown'
            },
            ...this.options
        };
        document.addEventListener('DOMContentLoaded', () => { this.init(); });
    }
    init() {
        return;
        let navbarToggler = document.querySelector(".navigation-toggler");
        if (navbarToggler) {
            navbarToggler.addEventListener("click", (e) => {
                console.log(e.target);
                let menu = document.querySelector(".main-navigation nav");
                if (menu.classList.contains("open")) {
                    menu.classList.remove("open");
                    navbarToggler.classList.remove("open");
                }
                else {
                    menu.classList.add("open");
                    navbarToggler.classList.add("open");
                }
            });
        }
        let dropdowns = document.querySelectorAll(".dropdown .dropdown-toggler");
        dropdowns.forEach((dropdown) => {
            dropdown.addEventListener("click", (e) => {
                e.stopImmediatePropagation();
                e.preventDefault();
                document.addEventListener("click", closeDropdowns);
                var menu = e.target.parentNode.querySelector("ul");
                if (menu) {
                    if (menu.classList.contains("show")) {
                        menu.classList.remove("show");
                    }
                    else {
                        menu.classList.add("show");
                    }
                }
            });
        });
        function closeDropdowns(e) {
            if (e.target.closest(".menu")) {
                return;
            }
            let menus = document.querySelectorAll(".menu .dropdown ul");
            menus.forEach((menu) => {
                menu.classList.remove("show");
            });
            document.removeEventListener("click", closeDropdowns);
        }
        this.setActive();
    }
    setActive() {
        var navList = document.querySelectorAll(this.options.selector);
        for (var i = 0; i < navList.length; i += 1) {
            var linkList = navList[i].querySelectorAll('li a');
            console.log(linkList);
            for (var q = 0; q < linkList.length; q += 1) {
                if (linkList[q].querySelector('.nav-link').getAttribute('href').toLowerCase() == location.href.toLowerCase()) {
                    this.toggleAncestor(linkList[q], true);
                    linkList[q].classList.add(this.options.activeClass);
                }
            }
        }
    }
    toggleAncestor(el, recursive = false) {
        this.options.debug && console.log("toggleAncestor", el, "Recursive: " + recursive);
        var ancestor = el.closest(this.options.dropdownSelector);
        this.options.debug && (ancestor != null ? console.log("Ancestor found: ", ancestor) : console.log("Ancestor not found"));
        if (ancestor !== null) {
            ancestor.querySelector('input[type="checkbox"]').checked = true;
            ancestor.classList.add(this.options.activeClass);
            recursive && this.toggleAncestor(ancestor.parentElement, true);
        }
    }
}
